import { APIRoutes } from "../../../../constants";
import { RequestServer } from "../../../../utils/services";

type responseType = {
  success: boolean;
  message: string;
  data: any[];
};

export type mails = {
  fetched_mails: any[];
  deleted: any[];
  added: any[];
  workstreams: any[];
  projectName: string;
  loading: boolean;
  changed: boolean;
};

export type notifications = {
  status: boolean;
  message: string;
  loading: boolean;
};


export const getSubscribedMails = async (setMailState: (r: mails) => void, projectId: string | null) => {
  setMailState({ fetched_mails: [],deleted: [],added: [], loading: true, changed: false, projectName: '', workstreams:[] });
  try {
    const response = await RequestServer(
    `${APIRoutes.INVITE_SUBSCRIPTIONS}${projectId}`,
    'GET'
    );
    const data = response?.data
    if (data) {
      setMailState({
        fetched_mails: data.emails,
        projectName: data.name,
        loading: false,
        changed: false,
        deleted: [],
        added: [],
        workstreams: data.linked_workstreams
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const updateSubscribedMails = async (setMailState: (r: mails) => void, mailState: mails, projectId: string | null) => {
  setMailState({
    fetched_mails: mailState.fetched_mails,
    projectName: mailState.projectName,
    workstreams: mailState.workstreams,
    loading: true,
    changed: true,
    deleted: mailState.deleted,
    added: mailState.added
  })
  try {
    const response = await RequestServer(
    `${APIRoutes.UPDATE_INVITE_SUBSCRIPTIONS}`,
    'PUT',
    {id: projectId, emails: mailState.fetched_mails}
    );
    if(!response.success){
      throw new Error(response.message)
    }
    if ((window as any).enqueueSnackbar&&response.success) {
      (window as any).enqueueSnackbar("Update successful", {
        variant: "success",
      });
    }
    const data = response?.data
    if (data) {
      setMailState({
        fetched_mails: data.emails,
        projectName: data.name,
        workstreams: data.linked_workstreams,
        loading: false,
        changed: false,
        deleted: [],
        added: []
      });
    }
    
  } catch (err: any) {
    setMailState({
      fetched_mails: mailState.fetched_mails,
      projectName: mailState.projectName,
      workstreams: mailState.workstreams,
      loading: false,
      changed: true,
      deleted: mailState.deleted,
      added: mailState.added
    })
    if ((window as any).enqueueSnackbar) {
      (window as any).enqueueSnackbar(`${err}`, {
        variant: "error",
      });
    }
  }
};
export const updateNotificationState = async (
  newValue: boolean,
  setNotificationState: (state: notifications) => void,
  projectId: string | null
): Promise<void> => {
  if (!projectId) {
    setNotificationState({
      status: false,
      message: 'Project ID is missing.',
      loading: false,
    });
    return;
  }
  setNotificationState({ status: false, message: '', loading: true });
  try {
    const response = await RequestServer(
      `${APIRoutes.TRIGGER_NOTIFICATIONS}${projectId}`,
      'POST', {id: projectId}
    );
    const message = 'Something Went Wrong';
    setNotificationState({
      status: newValue,
      message: response.message,
      loading: false,
    });
  } catch (error: any) {
    console.error('Error triggering notifications:', error);
    setNotificationState({
      status: false,
      message: error?.message || 'Something went wrong.',
      loading: false,
    });
  }
};